/* eslint-disable import/order */

import { ReactComponent as AddSquare } from './add-square.svg'
import { ReactComponent as AddCircleWhite } from './add-circle-white.svg'
import { ReactComponent as TeacherIcon } from './teacher-icon.svg'
import { ReactComponent as PlayerReportIcon } from './player-report-icon.svg'
import { ReactComponent as FaqIcon } from './faq-icon.svg'
import { ReactComponent as ArrowUp } from './arrow-up.svg'
import { ReactComponent as WinPotd } from './win-potd.svg'
import { ReactComponent as TopTenSqure } from './top-ten-squre.svg'
import { ReactComponent as Sticker200 } from './stickers-200-week.svg'
import { ReactComponent as Sticker1000 } from './sticker-1000.svg'
import { ReactComponent as Sticker2000 } from './sticker-2000.svg'
import { ReactComponent as Sticker3000 } from './sticker-3000.svg'
import { ReactComponent as Sticker4000 } from './sticker-4000.svg'
import { ReactComponent as Sticker5000 } from './sticker-5000.svg'
import { ReactComponent as Sticker6000 } from './sticker-6000.svg'
import { ReactComponent as Sticker8000 } from './sticker-8000.svg'
import { ReactComponent as Sticker10000 } from './sticker-10000.svg'
import { ReactComponent as StickerLocked } from './sticker-lock.svg'
import { ReactComponent as CompleteSs1 } from './complete-ss1.svg'
import { ReactComponent as CompleteSs2 } from './complete-ss2.svg'
import { ReactComponent as CompleteSs3 } from './complete-ss3.svg'
import { ReactComponent as CompleteSs4 } from './complete-ss4.svg'
import { ReactComponent as CompleteSs5 } from './complete-ss5.svg'
import { ReactComponent as CompleteSs6 } from './complete-ss6.svg'
import { ReactComponent as CompleteSs7 } from './complete-ss7.svg'
import { ReactComponent as CompleteSs8 } from './complete-ss8.svg'
import { ReactComponent as LockedSs } from './skill-set-lock.svg'
import { ReactComponent as CompleteJTFNumPre } from './complete-jtf-num-pre.svg'
import { ReactComponent as CompleteJTFFrcPre } from './complete-jtf-frc-pre.svg'
import { ReactComponent as CompleteJTFDecPre } from './complete-jtf-dec-pre.svg'
import { ReactComponent as CompleteJTFIntPre } from './complete-jtf-int-pre.svg'
import { ReactComponent as CompleteJTFNumPost } from './complete-jtf-num-post.svg'
import { ReactComponent as CompleteJTFFrcPost } from './complete-jtf-frc-post.svg'
import { ReactComponent as CompleteJTFDecPost } from './complete-jtf-dec-post.svg'
import { ReactComponent as CompleteJTFIntPost } from './complete-jtf-int-post.svg'
import { ReactComponent as JtfLocked } from './jft-lock.svg'
import { ReactComponent as CompleteGymNumAdd } from './complete-gym-num-add.svg'
import { ReactComponent as CompleteGymNumSub } from './complete-gym-num-sub.svg'
import { ReactComponent as CompleteGymNumMul } from './complete-gym-num-mul.svg'
import { ReactComponent as CompleteGymNumDiv } from './complete-gym-num-div.svg'
import { ReactComponent as CompleteGymFrcAdd } from './complete-gym-frc-add.svg'
import { ReactComponent as CompleteGymFrcSub } from './complete-gym-frc-sub.svg'
import { ReactComponent as CompleteGymFrcMul } from './complete-gym-frc-mul.svg'
import { ReactComponent as CompleteGymFrcDiv } from './complete-gym-frc-div.svg'
import { ReactComponent as GymLocked } from './gym-lock.svg'
import { ReactComponent as CompleteGymDecAdd } from './complete-gym-dec-add.svg'
import { ReactComponent as CompleteGymDecSub } from './complete-gym-dec-sub.svg'
import { ReactComponent as CompleteGymDecMul } from './complete-gym-dec-mul.svg'
import { ReactComponent as CompleteGymDecDiv } from './complete-gym-dec-div.svg'
import { ReactComponent as CompleteGymIntAdd } from './complete-gym-int-add.svg'
import { ReactComponent as CompleteGymIntSub } from './complete-gym-int-sub.svg'
import { ReactComponent as CompleteGymIntMul } from './complete-gym-int-mul.svg'
import { ReactComponent as CompleteGymIntDiv } from './complete-gym-int-div.svg'
import { ReactComponent as Kas3Milestone3 } from './kas-3-milestone-3.svg'
import { ReactComponent as Kas3Milestone5 } from './kas-3-milestone-5.svg'
import { ReactComponent as Kas3Milestone7 } from './kas-3-milestone-7.svg'
import { ReactComponent as Kas3Milestone9 } from './kas-3-milestone-9.svg'
import { ReactComponent as Kas5Milestone3 } from './kas-5-milestone-3.svg'
import { ReactComponent as Kas5Milestone5 } from './kas-5-milestone-5.svg'
import { ReactComponent as Kas5Milestone7 } from './kas-5-milestone-7.svg'
import { ReactComponent as Kas5Milestone9 } from './kas-5-milestone-9.svg'
import { ReactComponent as KnsLocked } from './kns-lock.svg'
import { ReactComponent as CompleteMwGame } from './complete-mw-game.svg'
import { ReactComponent as MeasurementLocked } from './measurement-lock.svg'
import { ReactComponent as CompleteCtGame } from './complete-ct-game.svg'
import { ReactComponent as Complete10Mw } from './complete-10-mw.svg'
import { ReactComponent as Complete10Bonus } from './complete-10-bonus.svg'
import { ReactComponent as BonusGameLocked } from './bonus-game-lock.svg'
import { ReactComponent as CompleteBonusGame } from './complete-bonus-game.svg'
import { ReactComponent as WinPotdLock } from './win-potd-lock.svg'
import { ReactComponent as TryRps } from './try-rps-epic.svg'
import { ReactComponent as TryRpsLock } from './try-rps-lock.svg'
import { ReactComponent as Sticker200Lock } from './sticker-200-lock.svg'
import { ReactComponent as CtGameLock } from './ct-game-lock.svg'
import { ReactComponent as Kid1 } from './kid-1.svg'
import { ReactComponent as Kid2 } from './kid-2.svg'
import { ReactComponent as Kid3 } from './kid-3.svg'
import { ReactComponent as Kid4 } from './kid-4.svg'
import { ReactComponent as Kid5 } from './kid-5.svg'
import { ReactComponent as Kid6 } from './kid-6.svg'
import { ReactComponent as Kid7 } from './kid-7.svg'
import { ReactComponent as Kid8 } from './kid-8.svg'
import { ReactComponent as Kid9 } from './kid-9.svg'
import { ReactComponent as Kid10 } from './kid-10.svg'
import { ReactComponent as Kid11 } from './kid-11.svg'
import { ReactComponent as Kid12 } from './kid-12.svg'
import { ReactComponent as Kid13 } from './kid-13.svg'
import { ReactComponent as Kid14 } from './kid-14.svg'
import { ReactComponent as Kid15 } from './kid-15.svg'
import { ReactComponent as Kid16 } from './kid-16.svg'
import { ReactComponent as Kid17 } from './kid-17.svg'
import { ReactComponent as Kid18 } from './kid-18.svg'
import { ReactComponent as Kid19 } from './kid-19.svg'
import { ReactComponent as Kid20 } from './kid-20.svg'
import { ReactComponent as Kid21 } from './kid-21.svg'
import { ReactComponent as Kid22 } from './kid-22.svg'
import { ReactComponent as Kid23 } from './kid-23.svg'
import { ReactComponent as Kid24 } from './kid-24.svg'
import { ReactComponent as Kid25 } from './kid-25.svg'
import { ReactComponent as Kid26 } from './kid-26.svg'
import { ReactComponent as Kid27 } from './kid-27.svg'
import { ReactComponent as Kid28 } from './kid-28.svg'
import { ReactComponent as Kid29 } from './kid-29.svg'
import { ReactComponent as Kid30 } from './kid-30.svg'
import { ReactComponent as CatAvatar } from './catavatar.svg'
import { ReactComponent as DogAvatar } from './dog-avatar.svg'
import { ReactComponent as SquirrelAvatar } from './squirrel.svg'
import { ReactComponent as BuffaloAvatar } from './buffalo-avatar.svg'
import { ReactComponent as LionAvatar } from './lion-avatar.svg'
import { ReactComponent as OwlAvatar } from './owl-avatar.svg'
import { ReactComponent as HorseAvatar } from './horse.svg'
import { ReactComponent as TigerAvatar } from './tiger.svg'
import { ReactComponent as JagurAvatar } from './jaguar.svg'
import { ReactComponent as ZebraAvatar } from './zebra.svg'
import { ReactComponent as TreeAvatar } from './treeavatar.svg'
import { ReactComponent as Christmastree } from './christmastree.svg'
import { ReactComponent as RoseAvatar } from './rose-avatar.svg'
import { ReactComponent as SunflowerAvatar } from './sunflower-avatar.svg'
import { ReactComponent as leafAvatar } from './leaf-avatar.svg'
import { ReactComponent as EarthAvatar } from './earth-avatar.svg'
import { ReactComponent as MarsAvatar } from './mars-avatar.svg'
import { ReactComponent as MoonAvatar } from './moon-avatar.svg'
import { ReactComponent as RocketAvatar } from './rocket-avatar.svg'
import { ReactComponent as TelescopeAvatar } from './telescope-avatar.svg'
import { ReactComponent as ChessAvatar } from './chess-avatar.svg'
import { ReactComponent as GameConsole } from './game-console.svg'
import { ReactComponent as SolitaireAvatar } from './solitaire-avatar.svg'
import { ReactComponent as BowlingAvatar } from './bowling-avatar.svg'
import { ReactComponent as SkeaterAvatar } from './skeater.svg'
import { ReactComponent as SketeBoardAvatar } from './skateboard.svg'
import { ReactComponent as BicycleAvatar } from './bicycle.svg'
import { ReactComponent as RacingAvatar } from './racing-car.svg'
import { ReactComponent as AeroPlaneAvatar } from './aeroplane.svg'
import { ReactComponent as ShipAvatar } from './ship.svg'
import { ReactComponent as GcSticker } from './gc-sticker.svg'
import { ReactComponent as TwoXsticker } from './2x-sticker.svg'
import { ReactComponent as ThreeXsticker } from './3x-sticker.svg'
import { ReactComponent as FourXsticker } from './4x-sticker.svg'
import { ReactComponent as FiveXsticker } from './5x-sticker.svg'
import { ReactComponent as SixXsticker } from './6x-sticker.svg'
import { ReactComponent as SevenXsticker } from './7x-sticker.svg'
import { ReactComponent as EightXsticker } from './8x-sticker.svg'
import { ReactComponent as NineXsticker } from './9x-sticker.svg'
import { ReactComponent as TenXsticker } from './10x-sticker.svg'
import { ReactComponent as GcStickerLock } from './gc-sticker-lock.svg'
import { ReactComponent as TwoXstickerLock } from './2x-sticker-lock.svg'
import { ReactComponent as ThreeXstickerLock } from './3x-sticker-lock.svg'
import { ReactComponent as FourXstickerLock } from './4x-sticker-lock.svg'
import { ReactComponent as FiveXstickerLock } from './5x-sticker-lock.svg'
import { ReactComponent as SixXstickerLock } from './6x-sticker-lock.svg'
import { ReactComponent as SevenXstickerLock } from './7x-sticker-lock.svg'
import { ReactComponent as EightXstickerLock } from './8x-sticker-lock.svg'
import { ReactComponent as NineXstickerLock } from './9x-sticker-lock.svg'
import { ReactComponent as TenXstickerLock } from './10x-sticker-lock.svg'
import { ReactComponent as FootballIcon } from './football-icon.svg'
import { ReactComponent as AmericanFootball } from './american-football.svg'
import { ReactComponent as BasketBall } from './basketball.svg'
import { ReactComponent as Baseball } from './baseball.svg'
import { ReactComponent as Volleyball } from './volleyball.svg'
import { ReactComponent as TennisIcon } from './tennis-icon.svg'
import { ReactComponent as PaddleBall } from './paddle-ball.svg'
import { ReactComponent as IceHockey } from './Icehockey.svg'
import { ReactComponent as HockeyIcon } from './hockey.svg'
import { ReactComponent as BoomerangIcon } from './boomerang.svg'
import { ReactComponent as Guitar } from './guitar.svg'
import { ReactComponent as ElectricGuitar } from './electric-guitar.svg'
import { ReactComponent as CasioIcon } from './casio-icon.svg'
import { ReactComponent as TrumpetIcon } from './trumpet-icon.svg'
import { ReactComponent as CelloGuitar } from './cello-guitar.svg'
import { ReactComponent as SaxoPhone } from './saxophone-icon.svg'
import { ReactComponent as DrumIcon } from './drum.svg'
import { ReactComponent as Flute } from './flute.svg'
import { ReactComponent as Piano } from './piano.svg'
import { ReactComponent as RockGuitar } from './rock-guitar.svg'
import { ReactComponent as StarIcon } from './star-icon.svg'
import { ReactComponent as MaxBonusGame } from './max-bonus-game.svg'
import { ReactComponent as StarBadge } from './Star-badge.svg'
import { ReactComponent as TopTen } from './top-ten.svg'
import { ReactComponent as ArrowGrey } from './arrow-grey.svg'
import { ReactComponent as Fire } from './Fire-icon.svg'
import { ReactComponent as RookieLarge } from './rookie-large.svg'
import { ReactComponent as StudentBadgeLarge } from './student-badge-large.svg'
import { ReactComponent as LightBadge } from './light-icon.svg'
import { ReactComponent as AceBadgeLarge } from './ace-icon-large.svg'
import { ReactComponent as ExpertBadgeLarge } from './expert-large-badge.svg'
import { ReactComponent as AwardBadge } from './award-badge.svg'
import { ReactComponent as MicroScope } from './microscope.svg'
import { ReactComponent as TelescopeBadge } from './telescope-large.svg'
import { ReactComponent as TrophyLarge } from './trophy-large.svg'
import { ReactComponent as TrophySmall } from './trophy-small.svg'
import { ReactComponent as RookieIcon } from './rookie-icon.svg'
import { ReactComponent as ScholarBadge } from './Scholar-badge.svg'
import { ReactComponent as WhizBadge } from './whiz-badges.svg'
import { ReactComponent as AceBadge } from './ace-badge.svg'
import { ReactComponent as StudentBadge } from './student-badge-icon.svg'
import { ReactComponent as MathematicianBadge } from './mathematician-badge.svg'
import { ReactComponent as GeniusBadge } from './genius-badge.svg'
import { ReactComponent as ExpertBadge } from './expert-badge.svg'
import { ReactComponent as MastermindBadge } from './mastermind-badge.svg'
import { ReactComponent as ChampionBadge } from './champion-badge.svg'
import { ReactComponent as ScholarBadgeLock } from './scholar-badge-lock.svg'
import { ReactComponent as RookieIconLock } from './rookie-badge-lock.svg'
import { ReactComponent as WhizBadgeLock } from './whiz-badge-lock.svg'
import { ReactComponent as AceBadgeLock } from './ace-badge-lock.svg'
import { ReactComponent as StudentBadgeLock } from './student-badge-lock.svg'
import { ReactComponent as MathematicianBadgeLock } from './mathematician-badge-lock.svg'
import { ReactComponent as GeniusBadgeLock } from './genius-badge-lock.svg'
import { ReactComponent as ExpertBadgeLock } from './expert-badge-lock.svg'
import { ReactComponent as MastermindBadgeLock } from './mastermind-badge-lock.svg'
import { ReactComponent as ChampionBadgeLock } from './champion-badge-lock.svg'
import { ReactComponent as PaperBadge } from './paper.svg'
import { ReactComponent as PlainPaper } from './plain-paper.svg'
import { ReactComponent as Pencil } from './pencil-icon.svg'
import { ReactComponent as SearchGrey } from './SearchGrey.svg'
import { ReactComponent as Feedbackicon } from './Feedback-icon.svg'
import { ReactComponent as Appfeedback } from './Appfeedback-icon.svg'
import { ReactComponent as MessageIcon } from './message-icon.svg'
import { ReactComponent as WdykCheckBoxChecked } from './Wdyk-checkbox-checked.svg'
import { ReactComponent as CheckBoxCross } from './Checkbox-cross.svg'
import { ReactComponent as StickerCount } from './Sticker-count.svg'
import { ReactComponent as PotdIcon } from './potd-star-icon.svg'
import { ReactComponent as TrophyIcon } from './Union.svg'
import { ReactComponent as EditWhite } from './edit-white-bg.svg'
import { ReactComponent as EditCircle } from './edit-circle.svg'
import { ReactComponent as Feedback } from './feedback-button.svg'
import { ReactComponent as SkillsetCover } from './skillset-cover-icon.svg'
import { ReactComponent as AllStudentsIndicator } from './allstudents-indicator.svg'
import { ReactComponent as ArrowDown } from './arrow-down.svg'
import { ReactComponent as ArrowSquareDown } from './arrow-square-down.svg'
import { ReactComponent as CaretUpPurple } from './caret-up-purple.svg'
import { ReactComponent as CheckboxCheckedLg } from './checkbox-checked-lg.svg'
import { ReactComponent as CheckboxCheckedSm } from './checkbox-checked-sm.svg'
import { ReactComponent as CheckboxChecked } from './checkbox-checked.svg'
import { ReactComponent as CheckboxEmptyLg } from './checkbox-empty-lg.svg'
import { ReactComponent as CheckboxSm } from './checkbox-sm.svg'
import { ReactComponent as Checkbox } from './checkbox.svg'
import { ReactComponent as CloseSimple } from './close-simple.svg'
import { ReactComponent as Courthouse } from './courthouse.svg'
import { ReactComponent as DirectInbox } from './direct-inbox.svg'
import { ReactComponent as DirectSend } from './direct-send.svg'
import { ReactComponent as Edit } from './edit.svg'
import { ReactComponent as ElementPlus } from './element-plus.svg'
import { ReactComponent as EmailFill } from './email-fill.svg'
import { ReactComponent as EmailOpened } from './email-opened.svg'
import { ReactComponent as EmergingIndiCator } from './emerging-indicator.svg'
import { ReactComponent as EyeSlash } from './eye-slash.svg'
import { ReactComponent as Eye } from './eye.svg'
import { ReactComponent as FluentIndicator } from './fluent-indicator.svg'
import { ReactComponent as SquareMenu } from './square-menu-default.svg'
import { ReactComponent as POTDTrophy } from './potd-trophy.svg'
import POTDTrophyPng from './potd-trophy.png'
import { ReactComponent as Gameboy } from './gameboy.svg'
import Gyms from './gyms-blue.png'
import Jtf from './just-the-facts.png'
import Vif from './very-important-facts.png'
import Ss from './skill-set.png'
import Wpf from './word-problem-fluency.png'
import Activity from './activity.png'
import { ReactComponent as Hashtag } from './hashtag.svg'
import { ReactComponent as InfoCircleLg } from './info-circle-lg.svg'
import { ReactComponent as InfoCircleSm } from './info-circle-sm.svg'
import { ReactComponent as InfoCircle } from './info-circle.svg'
import { ReactComponent as LineArrowRight } from './line-arrow-right.svg'
import { ReactComponent as LoginClose } from './login-close.svg'
import Logo from './logo.svg'
import { ReactComponent as MenuIcon } from './menu-icon.svg'
import { ReactComponent as More } from './more.svg'
import { ReactComponent as NeedHelpIndicator } from './needhelp-indicator.svg'
import { ReactComponent as Teacher } from './teacher.svg'
import { ReactComponent as ProficientIndicator } from './proficient-indicator.svg'
import { ReactComponent as ProfileCircle } from './profile-circle.svg'
import { ReactComponent as Search2 } from './search-2.svg'
import { ReactComponent as SearchIcon } from './searchi-con.svg'
import { ReactComponent as Send2 } from './send-2.svg'
import { ReactComponent as Send } from './send.svg'
import { ReactComponent as SettingTable } from './setting-table.svg'
import { ReactComponent as StarOnly } from './star-only.svg'
import Top10Awards from './top10awards.png'
import { ReactComponent as UserCircleAdd } from './user-circle-add.svg'
import { ReactComponent as User } from './user.svg'
import { ReactComponent as RotateDevice } from './refresh.svg'
import { ReactComponent as RefreshSquare } from './refresh-square-2.svg'
import { ReactComponent as SearchZoomIn } from './search-zoom-in.svg'
import { ReactComponent as HelpCircle } from './help-circle.svg'
import { ReactComponent as Slash } from './slash.svg'
import { ReactComponent as FlashCircle } from './flash-circle.svg'
import { ReactComponent as TrashBlue } from './trash-blue.svg'
import WedgeFactFluencyBlue from './wedge-fact-fluency-blue.png'
import WedgeFactFluencyGreen from './wedge-fact-fluency-green.png'
import WedgeFactFluencyPurple from './wedge-fact-fluency-purple.png'
import WedgeFactFluencyRed from './wedge-fact-fluency-red.png'
import { ReactComponent as Pdf } from './document-text.svg'
import { ReactComponent as PreviousPrimaryArrow } from './outline_arrow-left.svg'

const images = {
  AddSquare,
  AllStudentsIndicator,
  ArrowDown,
  ArrowSquareDown,
  CheckboxCheckedLg,
  CheckboxCheckedSm,
  CheckboxChecked,
  CheckboxEmptyLg,
  CheckboxSm,
  Checkbox,
  CloseSimple,
  Courthouse,
  DirectInbox,
  DirectSend,
  Edit,
  EditCircle,
  ElementPlus,
  EmailFill,
  EmailOpened,
  EmergingIndiCator,
  EyeSlash,
  Eye,
  FluentIndicator,
  Gameboy,
  Hashtag,
  InfoCircleLg,
  InfoCircleSm,
  InfoCircle,
  LineArrowRight,
  LoginClose,
  Logo,
  MenuIcon,
  More,
  NeedHelpIndicator,
  ProficientIndicator,
  ProfileCircle,
  Search2,
  SearchIcon,
  Send2,
  Send,
  SettingTable,
  StarOnly,
  Top10Awards,
  UserCircleAdd,
  User,
  WedgeFactFluencyBlue,
  WedgeFactFluencyGreen,
  WedgeFactFluencyPurple,
  WedgeFactFluencyRed,
  Gyms,
  Jtf,
  Vif,
  Ss,
  Wpf,
  Activity,
  RotateDevice,
  Pdf,
  PreviousPrimaryArrow,
  SquareMenu,
  RefreshSquare,
  SearchZoomIn,
  HelpCircle,
  Slash,
  FlashCircle,
  TrashBlue,
  Teacher,
  POTDTrophy,
  POTDTrophyPng,
  AddCircleWhite,
  SkillsetCover,
  EditWhite,
  Feedback,
  StickerCount,
  PotdIcon,
  TrophyIcon,
  Feedbackicon,
  Appfeedback,
  MessageIcon,
  WdykCheckBoxChecked,
  CheckBoxCross,
  SearchGrey,
  Pencil,
  ArrowGrey,
  Fire,
  StarIcon,
  TopTen,
  MaxBonusGame,
  WinPotd,
  RookieIcon,
  StarBadge,
  ScholarBadge,
  StudentBadge,
  WhizBadge,
  AceBadge,
  ExpertBadge,
  MathematicianBadge,
  GeniusBadge,
  MastermindBadge,
  ChampionBadge,
  Sticker200,
  Sticker1000,
  Sticker2000,
  Sticker3000,
  Sticker4000,
  Sticker5000,
  Sticker6000,
  Sticker8000,
  Sticker10000,
  CompleteSs1,
  CompleteSs2,
  CompleteSs3,
  CompleteSs4,
  CompleteSs5,
  CompleteSs6,
  CompleteSs7,
  CompleteSs8,
  CompleteJTFNumPre,
  CompleteJTFFrcPre,
  CompleteJTFDecPre,
  CompleteJTFIntPre,
  CompleteJTFNumPost,
  CompleteJTFFrcPost,
  CompleteJTFDecPost,
  CompleteJTFIntPost,
  CompleteGymNumAdd,
  CompleteGymNumSub,
  CompleteGymNumMul,
  CompleteGymNumDiv,
  CompleteGymFrcAdd,
  CompleteGymFrcSub,
  CompleteGymFrcMul,
  CompleteGymFrcDiv,
  CompleteGymDecAdd,
  CompleteGymDecSub,
  CompleteGymDecMul,
  CompleteGymDecDiv,
  CompleteGymIntAdd,
  CompleteGymIntSub,
  CompleteGymIntMul,
  CompleteGymIntDiv,
  Kas3Milestone3,
  Kas3Milestone5,
  Kas3Milestone7,
  Kas3Milestone9,
  Kas5Milestone3,
  Kas5Milestone5,
  Kas5Milestone7,
  Kas5Milestone9,
  PaperBadge,
  PlainPaper,
  TeacherIcon,
  PlayerReportIcon,
  FaqIcon,
  FootballIcon,
  AmericanFootball,
  BasketBall,
  Baseball,
  Volleyball,
  TennisIcon,
  PaddleBall,
  IceHockey,
  HockeyIcon,
  BoomerangIcon,
  Guitar,
  ElectricGuitar,
  CasioIcon,
  TrumpetIcon,
  CelloGuitar,
  SaxoPhone,
  DrumIcon,
  Flute,
  Piano,
  RockGuitar,
  CatAvatar,
  DogAvatar,
  SquirrelAvatar,
  BuffaloAvatar,
  LionAvatar,
  OwlAvatar,
  HorseAvatar,
  TigerAvatar,
  JagurAvatar,
  ZebraAvatar,
  TreeAvatar,
  Christmastree,
  RoseAvatar,
  SunflowerAvatar,
  leafAvatar,
  EarthAvatar,
  MarsAvatar,
  MoonAvatar,
  RocketAvatar,
  TelescopeAvatar,
  ChessAvatar,
  GameConsole,
  SolitaireAvatar,
  BowlingAvatar,
  SkeaterAvatar,
  SketeBoardAvatar,
  BicycleAvatar,
  RacingAvatar,
  AeroPlaneAvatar,
  ShipAvatar,
  GcSticker,
  TwoXsticker,
  ThreeXsticker,
  FourXsticker,
  FiveXsticker,
  SixXsticker,
  SevenXsticker,
  EightXsticker,
  NineXsticker,
  TenXsticker,
  RookieLarge,
  StudentBadgeLarge,
  LightBadge,
  AceBadgeLarge,
  ExpertBadgeLarge,
  AwardBadge,
  MicroScope,
  TelescopeBadge,
  TrophyLarge,
  TrophySmall,
  CompleteMwGame,
  CompleteCtGame,
  CompleteBonusGame,
  Complete10Mw,
  Complete10Bonus,
  ScholarBadgeLock,
  WhizBadgeLock,
  AceBadgeLock,
  StudentBadgeLock,
  MathematicianBadgeLock,
  GeniusBadgeLock,
  ExpertBadgeLock,
  MastermindBadgeLock,
  ChampionBadgeLock,
  GcStickerLock,
  TwoXstickerLock,
  ThreeXstickerLock,
  FourXstickerLock,
  FiveXstickerLock,
  SixXstickerLock,
  SevenXstickerLock,
  EightXstickerLock,
  NineXstickerLock,
  TenXstickerLock,
  RookieIconLock,
  StickerLocked,
  LockedSs,
  JtfLocked,
  GymLocked,
  KnsLocked,
  MeasurementLocked,
  BonusGameLocked,
  WinPotdLock,
  TryRpsLock,
  Sticker200Lock,
  CtGameLock,
  ArrowUp,
  Kid1,
  Kid2,
  Kid3,
  Kid4,
  Kid5,
  Kid6,
  Kid7,
  Kid8,
  Kid9,
  Kid10,
  Kid11,
  Kid12,
  Kid13,
  Kid14,
  Kid15,
  Kid16,
  Kid17,
  Kid18,
  Kid19,
  Kid20,
  Kid21,
  Kid22,
  Kid23,
  Kid24,
  Kid25,
  Kid26,
  Kid27,
  Kid28,
  Kid29,
  Kid30,
  TryRps,
  TopTenSqure,
  CaretUpPurple
}

export default images
